import ProductMediaForm from './product-media-form'

export default ProductMediaForm;